import { createScimCredentialRequestSchema, createScimCredentialResponseSchema, disconnectScimProvisioningResponseSchema, scimProvisioningConfigSchema, } from '../contracts/scim-provisioning';
import { organizationIdSchema, } from '../contracts/organizations';
import { parseSchema } from '../errors';
/**
 * Get the organization's SCIM provisioning view: the project-level SCIM base URL
 * plus this org's single active credential (or null when not connected).
 */
export async function getScimProvisioning(client, organizationId) {
    const validatedId = parseSchema(organizationIdSchema, organizationId);
    const data = await client.get(`/organizations/${validatedId}/scim-provisioning`);
    return parseSchema(scimProvisioningConfigSchema, data);
}
/**
 * Generate (or replace) the org's SCIM credential. The one-time `bearerToken`
 * (`ProjectID:AccessKey`) comes back on this response only — never retrievable
 * again — so the caller must surface it immediately alongside the SCIM URL.
 * Generating when one already exists rotates it: the previous Descope key is
 * deactivated.
 */
export async function createScimCredential(client, organizationId, body) {
    const validatedId = parseSchema(organizationIdSchema, organizationId);
    const validatedBody = parseSchema(createScimCredentialRequestSchema, body);
    const data = await client.post(`/organizations/${validatedId}/scim-provisioning/credentials`, validatedBody);
    return parseSchema(createScimCredentialResponseSchema, data);
}
/**
 * Disconnect SCIM provisioning: the Descope key is deactivated and the stored
 * connection removed. The customer's IdP can no longer provision.
 */
export async function disconnectScimProvisioning(client, organizationId) {
    const validatedId = parseSchema(organizationIdSchema, organizationId);
    const data = await client.delete(`/organizations/${validatedId}/scim-provisioning`);
    return parseSchema(disconnectScimProvisioningResponseSchema, data);
}
//# sourceMappingURL=scim-provisioning.js.map